import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const HypothesisTestingCalculators = () => {
  return (
    <div className="statistics-calculators max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="calculator-header mb-12">
        <div className="flex items-center gap-4">
          <div className="header-icon text-4xl">📊</div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Hypothesis Testing Calculators</h1>
            <p className="text-lg text-blue-600 font-semibold">Statistics Calculators</p>
          </div>
        </div>
      </div>

      <div className="calculator-description space-y-4 mb-12">
        <p className="text-gray-700">
          Select a hypothesis testing calculator to perform statistical tests and analyze your data.
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        <Link to="/calculator/t-test" className="calculator-card bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2">T-Test Calculator</h3>
          <p className="text-gray-600">Compare means of two groups</p>
        </Link>

        <Link to="/calculator/z-test" className="calculator-card bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2">Z-Test Calculator</h3>
          <p className="text-gray-600">Compare sample mean to population mean</p>
        </Link>

        <Link to="/calculator/chi-square-test" className="calculator-card bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2">Chi-Square Test Calculator</h3>
          <p className="text-gray-600">Test independence of categorical variables</p>
        </Link>

        <Link to="/calculator/anova" className="calculator-card bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2">ANOVA Calculator</h3>
          <p className="text-gray-600">Compare means of three or more groups</p>
        </Link>

        <Link to="/calculator/mann-whitney-u-test" className="calculator-card bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2">Mann-Whitney U Test Calculator</h3>
          <p className="text-gray-600">Compare medians of two groups (non-parametric)</p>
        </Link>

        <Link to="/calculator/wilcoxon-signed-rank-test" className="calculator-card bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-semibold mb-2">Wilcoxon Signed-Rank Test Calculator</h3>
          <p className="text-gray-600">Compare paired samples (non-parametric)</p>
        </Link>
      </motion.div>
    </div>
  );
};

export default HypothesisTestingCalculators;
